import type { FaireProductEntity } from "../../entity_types/product";

export const p_wmq7bhk3pc: FaireProductEntity = {
  token: "p_wmq7bhk3pc",
  type: "product",
  name: "Peppermint Espresso Martini Frozen Cocktail",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/3bc4bee6768239ed2d3196b79b422ad6096f46dc1ba2b7d1e8c5ff465d7a7c25.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4a6a2ac1fcc33c738518ef372624438562e7be6d99573caa7aaf768c34bf6f91.jpeg",
  ],
  priceDollars: 8.5,
  description:
    "Frozen Seasonal Cocktails don't get easier than this! Each bag makes 8 servings. No blenders ever! Simply add 1.5 cups of vodka and 4.5 cups of water (total 6 cups of liquid), shake or stir and throw in the freezer. Then serve right from the bag. \n\nOur Frozen cocktails are unique in you ONLY ever add water and spirit...NEVER any juice, mixers or additional flavors. That's one of the things that sets us apart. 100% all natural ingredients and perfect to share with friends and family at your next party.\n\n- 100% All-Natural Ingredients\n- Easy Prep:  Mix, Freeze & Serve Directly in the Bag \n- No Artificial Flavors or Colors\n- Made in the USA\n- Vegan & Gluten-Free \n- Makes 8 Servings per Bag\n- No Blender Needed\n- Proven High Sell-Through\n- Strong Reorder Rate – Customer Favorite\n- Bold color and holiday design makes merchandising a breeze!\n-Perfect Christmas and hostess gifts for the entire holiday season",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:08:58.796Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
